import React from 'react'

const Main = () => (
  <main id="main" className="site-main">
    <section
      id="expertise"
      className="section"
      aria-labelledby="expertise-heading"
    >
      <h2 id="expertise-heading" className="major">
        Expertise &amp; solutions
      </h2>
      <p>
        I am a Site Reliability Engineer and lead developer focused on smart,
        practical solutions—over <strong>7+ years</strong> in that space and{' '}
        <strong>10+ years</strong> total in software engineering. I care about
        reliability, clear ownership, and helping teams ship with confidence.
      </p>
      <p>
        <strong>Education:</strong> Bachelor in Computer Application (BCA), RR
        Institute Of Technology (2012–2015). Earlier: SLC and +2 Science at Basu
        Higher Secondary (2007–2011).{' '}
        <strong>Certification:</strong> C#.Net (IIHT Ltd, 2014).
      </p>
      <p>Languages: English, Nepali, Hindi, and Nepal Bhasa.</p>
    </section>

    <section
      id="services"
      className="section"
      aria-labelledby="services-heading"
    >
      <h2 id="services-heading" className="major">
        Professional services
      </h2>

      <h3 className="work-period">Exotrac · Sep 2015 – Mar 2018</h3>
      <p>
        Software engineer in logistics and transportation (Bangalore). Built and
        maintained web applications and integrations using{' '}
        <strong>
          C#, ASP.NET MVC, WCF, SQL Server, SSIS, Windows services
        </strong>
        , API creation and third-party integration, payment portals,{' '}
        <strong>JavaScript, jQuery, and AngularJS</strong>.
      </p>

      <h3 className="work-period">UBA Solutions · Mar 2018 – present</h3>
      <p>
        Product engineering for global clients, including{' '}
        <strong>Monotype Inc.</strong>—type, fonts, and font technologies—
        delivered under UBA Solutions. Progression: Software Engineer → Senior
        Software Engineer → Associate Lead Engineer →{' '}
        <strong>Lead Site Reliability Engineer</strong> (from Mar 2024).
      </p>
      <p>
        Domains have included <strong>travel technology</strong> (hotels, flights,
        bus booking, payments, SignalR), <strong>ecommerce</strong> (Redis,
        Elasticsearch, third-party APIs), and broader{' '}
        <strong>logistics-style</strong> and platform work using C#, ASP.NET
        MVC/Web API, Entity Framework, SQL Server, WCF, and automation
        experience with tools such as Protractor and Selenium.
      </p>

      <h3 className="work-period">Current focus · Lead SRE</h3>
      <p>
        Leading reliability practices: resilience, observability-minded delivery,
        operational readiness, and raising the bar for how we build and run
        systems—partnering across engineering to reduce risk and improve
        customer-impacting outcomes.
      </p>
    </section>

    <section id="contact" className="section" aria-labelledby="contact-heading">
      <h2 id="contact-heading" className="major">
        Get in touch
      </h2>
      <p className="contact-lead">
        <strong>Email:</strong>{' '}
        <a href="mailto:amritthapaliya@gmail.com">amritthapaliya@gmail.com</a>
      </p>
      <p>
        For professional history and recommendations, see{' '}
        <a
          href="https://www.linkedin.com/in/amrit-thapaliya/"
          target="_blank"
          rel="noopener noreferrer"
        >
          LinkedIn
        </a>
        . Code and open-source activity:{' '}
        <a
          href="https://github.com/Amrit-thapaliya"
          target="_blank"
          rel="noopener noreferrer"
        >
          GitHub
        </a>
        .
      </p>
    </section>
  </main>
)

export default Main
